import { Component, Injector } from '@angular/core';

import { DAO } from './modal/DAO';
import { MessageService } from 'primeng/api';
import { ConfirmationDialogService } from './services/confirmationDialog.service';
import { Router } from '@angular/router';
import { Auth0UserService } from './services/auth0UserService.service';
import { FetchInterceptorService } from './services/fetch-interceptor.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [FetchInterceptorService]
})
export class AppComponent {
  title = 'BSB';
  userName: string;
  public currentPath: string = '';
  public static ReceivedOrCancelled: string  = "ReceivedOrCancelled";

    constructor(public dao: DAO, private messageService: MessageService,
        private confirmationDialogService: ConfirmationDialogService, public router: Router,
        private fetchInterceptorService: FetchInterceptorService,
        private injector: Injector) {
          fetchInterceptorService.Install();
  }
  ngOnInit() {
    this.currentPath = window.location.pathname;
  }
  triggerLoader(type) {
    if (type === 'hide') {
      document.getElementById("loaderForServiceCall").style.display = 'none';
      document.getElementById("bodyOverlay").style.display = 'none';
      document.body.style.pointerEvents = "auto";
    } else {
      document.getElementById("loaderForServiceCall").style.display = 'block';
      document.getElementById("bodyOverlay").style.display = 'block';
      document.body.style.pointerEvents = "none";
    }
  }
  public addToast(type, header, body) {
    this.messageService.add({ key: 'toast', severity: type, summary: header, detail: body });
  }
  
  public displayErrorPopupifAnyHitFails() {
    this.messageService.add({ key: 'declinePopup', sticky: true, severity: 'error', summary: 'Your submission could not be transmitted at this time.  Please try again later or contact Berkley Small Business Solutions at help@berkleysmallbusiness.com for additional support.' });
  }
  public reload() {
    this.messageService.clear();
    document.body.style.pointerEvents = "visible";
    this.dao.PolicyTemplate = '';
    this.dao.PolicySubTemplate = 'newsubmission';
    this.router.navigateByUrl('/home');
  }
  public async duplicatePopup() {
    this.dao.isDuplicateDOT = true;
    this.messageService.add({ key: 'duplicatePopup', sticky: true, severity: 'error', summary: 'DOT# has already been submitted by your agency. Please contact Berkley Small Business Solutions at submissions@berkleysmallbusiness.com for additional support.' });
  }
  public registrationMsgPopup(body, logUserOut:boolean = false) {
    this.messageService.add({ key: 'registrationMsgPopup', sticky: true, severity: 'error', summary: body, data:logUserOut });
    document.body.style.pointerEvents = "none";
  }
  public registrationSuccessPopup(body) {
    this.messageService.add({ key: 'registrationSuccessPopup', sticky: true, severity: 'success', summary: body });
    document.body.style.pointerEvents = "none";
  }
  onReject(type, logUserOut: boolean) {
    this.messageService.clear(type);
    document.body.style.pointerEvents = "visible";
    if (logUserOut) {
      let auth0UserService = this.injector.get(Auth0UserService);
      location.href = auth0UserService.logOutUrl;
    }
  }

  ConfirmationHandler(response: string, messageData: any) {
    this.confirmationDialogService.updateDialogData({ response: response, data: messageData });
  }
  signOut() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      //set expiration on cookie
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    //also clear session storage
    sessionStorage.clear();
    window.location.href = '/';
  }
  
  ok(toastKeyName: string, flow : string = "") {
    this.messageService.clear(toastKeyName);
    document.body.style.pointerEvents = "visible";
    if(flow === 'Endorsement'){
      this.router.navigate(['/home'], { state: { data: 'endorsement' } });
    }
    if(flow === AppComponent.ReceivedOrCancelled){
      this.reload();
    }
    else if(flow === 'sessionExpired'){
      let auth0UserService = this.injector.get(Auth0UserService);
      window.location.href = auth0UserService.logOutUrl;
    }
  }
}

